import { render, staticRenderFns } from "./Adminpanel.vue?vue&type=template&id=20dcb859"
import script from "./Adminpanel.vue?vue&type=script&lang=js"
export * from "./Adminpanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports